import type { LegalDocument } from './types'

// Source: "MissFit Privacy Notice 082026 (1).pdf", version 1.0, effective August 23, 2026.
export const privacyNotice: LegalDocument = {
  path: '/privacy-notice',
  title: 'Privacy Notice',
  blocks: [
    { type: 'paragraph', text: [{ text: 'PRIVACY NOTICE · FOR PROSPECTIVE CLIENTS', bold: true }] },
    { type: 'title', text: 'Before You Become a Client' },
    {
      type: 'paragraph',
      text: 'How MissFit Coaching handles your information before you approve an engagement agreement.',
    },
    { type: 'paragraph', text: 'VERSION 1.0 · EFFECTIVE AUGUST 23, 2026' },
    {
      type: 'paragraph',
      text: 'If you book a consult, complete an intake form, or share your resume with MissFit Coaching before approving an engagement agreement, this notice explains how we handle your information. This notice is provided for your information; nothing needs to be signed or returned.',
    },
    { type: 'heading', text: 'What we collect' },
    {
      type: 'bullets',
      items: [
        [
          { text: 'What you share when booking: ', bold: true },
          { text: 'your name, contact details, and your answers to intake questions;' },
        ],
        [
          { text: 'Documents you send us: ', bold: true },
          { text: 'your resume and any career materials;' },
        ],
        [
          { text: 'Consult records: ', bold: true },
          {
            text: 'notes and, with the notice given in the meeting invite, recordings or transcripts of our conversation.',
          },
        ],
      ],
    },
    { type: 'heading', text: 'How we use it' },
    {
      type: 'paragraph',
      text: 'We use this information for one purpose: to understand your situation, evaluate whether we can genuinely help you, and prepare recommendations for our conversation. We do not sell your information, and we do not share it with third parties for their marketing. We use reputable service providers — scheduling, cloud storage, and AI-assisted analysis tools — to do this work, sharing only what the work requires, under provider terms that commit to confidentiality.',
    },
    { type: 'heading', text: 'How long we keep it' },
    {
      type: 'paragraph',
      text: 'If you become a client, your information is handled under your engagement agreement from its effective date. If you do not, we delete your intake materials, resume, and consult records within 6 months of our last contact, except records we must keep by law.',
    },
    { type: 'heading', text: 'Your choices' },
    {
      type: 'paragraph',
      text: 'You may ask for a copy of what we hold, ask us to correct it, or ask us to delete it sooner — at any time — by emailing dee@missfitcoaching.com. We will respond within a reasonable time and complete deletion requests within 30 days from active systems.',
    },
    { type: 'heading', text: 'Where you will see this notice' },
    {
      type: 'paragraph',
      text: 'So you always have this notice before you share anything, we provide it at each point we might collect your information:',
    },
    {
      type: 'bullets',
      items: [
        'A link in your Calendly booking confirmation when you schedule a consult;',
        'A link at the top of any intake form we ask you to complete;',
        'A standing link in the footer of missfitcoaching.com and missfitmindset.ai.',
      ],
    },
    { type: 'heading', text: 'Changes to this notice' },
    {
      type: 'paragraph',
      text: 'If we change this notice, we will update the version number and effective date above and post the current version at the locations listed here. Information collected before a change remains governed by the version in effect when you shared it, unless you agree otherwise.',
    },
    { type: 'heading', text: 'Contact' },
    {
      type: 'paragraph',
      text: 'Dee Dee Holdings LLC (d/b/a MissFit Coaching), Mount Prospect, Illinois · dee@missfitcoaching.com',
    },
  ],
}
